import { createContext, useContext, useState, useCallback } from "react";
import usersController from "../api/UsersController"; // ⚠️ import par défaut

const UsersContext = createContext();

export function UsersProvider({ children }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const fetchUsers = useCallback(async () => {
    setLoading(true);
    try {
      const result = await usersController.fetchAll();
      if (result.success) setUsers(result.data);
      else setError(result.message);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <UsersContext.Provider value={{
      users, loading, error, success,
      fetchUsers,
      clearError: () => setError(""),
      clearSuccess: () => setSuccess(""),
    }}>
      {children}
    </UsersContext.Provider>
  );
}

export const useUsers = () => useContext(UsersContext);
